/**
 * bienDichJsx — biên dịch script JSX của người dùng (trang / form / view / danh sách / báo cáo tuỳ biến) thành component React.
 *
 * LỖI ĐÃ GẶP (03/10/2026, trang "Trợ lý AI Marketing" + "Quy tắc phân bổ lead"): "Lỗi biên dịch trang …: Maximum call stack
 * size exceeded". Các màn hình Dynamic* trước đây làm:
 *     new Function(..., `return ${Babel.transform('(function X(props){…})').code}`)
 * Script có JSX spread (`<TextField {...p} />` — renderInput của Autocomplete) thì Babel chèn HÀM PHỤ lên ĐẦU mã:
 *     function _extends() { return _extends = Object.assign…, _extends.apply(null, arguments); }
 *     (function X(props){ … })
 * Ghép sau `return ` thành `return function _extends(){…}\n(function X…)` — xuống dòng KHÔNG ngắt câu trước dấu `(`, nên đó là
 * LỜI GỌI `_extends(X)`; trong biểu thức hàm có tên, gán lại `_extends` là vô hiệu nên nó gọi chính nó mãi -> tràn stack ngay lúc
 * "biên dịch". Script không có spread thì không có hàm phụ nên không ai thấy lỗi.
 *
 * Cách làm đúng: gán biểu thức vào một biến rồi `return` biến đó Ở CUỐI — hàm phụ Babel chèn ở đầu (bất kể loại nào) chỉ còn là
 * khai báo bình thường trong thân hàm khởi tạo.
 *
 * @param {object}   Babel        @babel/standalone (loadBabelOnce)
 * @param {string}   bieuThucHam  mã nguồn MỘT biểu thức hàm, vd "(function UserCustomPage(props){ … })"
 * @param {string[]} tenThamSo    tên các biến cấp sẵn cho mã, vd ['React', 'MUI', 'ContainerGrid']
 * @param {any[]}    giaTri       giá trị tương ứng
 * @returns {Function} component React
 */
export function bienDichComponent(Babel, bieuThucHam, tenThamSo = [], giaTri = []) {
  let ma = Babel.transform('var __thanhPhanTuyBien__ = ' + bieuThucHam + ';', { presets: ['react'] }).code;
  // Babel có thể thêm "use strict" ở đầu — giữ nguyên chế độ (không strict) như script cũ vẫn chạy.
  ma = ma.replace(/^\s*(["'])use strict\1;?/, '');
  // eslint-disable-next-line no-new-func
  const taoRa = new Function(...tenThamSo, ma + '\nreturn __thanhPhanTuyBien__;');
  const Component = taoRa(...giaTri);
  if (typeof Component !== 'function') throw new Error('Script không tạo ra được component (kết quả không phải hàm).');
  return Component;
}

export default bienDichComponent;
